export { InventoryDetailPage } from './view/inventory-detail-page';

export { default as inventoryDetailSlice } from './slice';
export { inventoryDetailSagas } from './sagas';
